import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_text = _resolveComponent("base-text")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_component_tooltip, {
    text: $props.description,
    tag: "div",
    class: _normalizeClass($options.classNames),
    enabled: !!$props.description
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_icon, {
        name: $options.iconName,
        size: "3x",
        class: _normalizeClass($options.classNames),
        "icon-namespace": $options.iconNamespace,
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, ["name", "class", "icon-namespace"]),
      _createVNode(_component_base_title, {
        as: "h4",
        level: "h3",
        class: "_mt-3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      ($props.caption)
        ? (_openBlock(), _createBlock(_component_base_text, {
            key: 0,
            level: "caption",
            class: "_tc--light-gray _mt-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.caption), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text", "class", "enabled"]))
}